import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Observable } from 'rxjs';

export interface PaymentTier {
  key: string;
  price: number;
  value: string;
}

@Injectable({
  providedIn: 'root'
})
export class PaymentTierService {

  constructor(private firestore: AngularFirestore) {}

  // Returns an observable of PaymentTier array
  getPaymentTiers(): Observable<PaymentTier[]> {
    return this.firestore
      .collection<PaymentTier>('payment_tiers')
      .valueChanges();
  }
}
